<div mat-dialog-title>Nouvelle note</div>
<div mat-dialog-content>
	<p></p>
	<div class="flex flex-col">
		<mat-form-field appearance="outline">
			<mat-label>Sélection</mat-label>
			<textarea
				matInput
				disabled
				[(ngModel)]="anchor"></textarea>
			<mat-icon matIconPrefix>label</mat-icon>
		</mat-form-field>
		<mat-form-field appearance="outline">
			<mat-label>Notes</mat-label>
			<textarea
				matInput
				[(ngModel)]="notes"></textarea>
			<mat-icon matIconPrefix>sticky_note_2</mat-icon>
		</mat-form-field>
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.cancel" | translate }}
	</button>
	@if (isLoading) {
		<mat-spinner diameter="40" />
	} @else {
		<button
			mat-raised-button
			color="primary"
			[disabled]="!isReady"
			(click)="create()">
			{{ "core.create" | translate }}
		</button>
	}
</div>
